<div class="bfpo_address__block">
    <div class="row pb-3" *ngIf="sAddressInfoConfig.isBfpoOptionEnabled">
        <span>{{'checkout.For Instructions on how to order for delivery to BFPO addresses' | translate | translateKey}}&nbsp;</span>
        <span>
            <a class="link--light" target="_blank"
                [href]="bfpoInstructionsUrl"><span>{{'checkout.Click here' | translate | translateKey}}</span></a>
        </span>
    </div>
    <div class="row auto-complete">
        <input type="text" [(ngModel)]="searchAddress" (ngModelChange)="resetAddressOptions()" (keyup)="typeHeadSelected=false;"
            (valueChanged)="typeHeadSelected = true;onSelectAddress($event)" ngui-auto-complete class="form-control"
            [display-property-name]="'displayName'" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
            [value-formatter]="autoCompleteValueFormatter" [source]="observableSource.bind(this)" [tab-to-select]="false"
            [min-chars]="3" [accept-user-input]="true" [open-on-focus]="false" [select-on-blur]="false"
            placeholder="{{'checkout.Enter Address for Search' | translate | translateKey}}"
            attr.aria-label="{{'checkout.Enter Address for Search' | translate | translateKey}}"
            attr.data-placeholder="{{'checkout.Enter Address for Search' | translate | translateKey}}" />
        <!-- Search Address spinner block start -->
        <span *ngIf="searchAddressProgress" tabindex="0" class="personal-info--email-info">
            <i class="fa fa-spinner"></i>
        </span>
        <!-- Search Address spinner block end -->
    </div>
    <div class="error pt-1" *ngIf="showErrorMessage">
        {{'checkout.Too little information, please enter more details' | translate | translateKey}}
    </div>
    <div class="address_options__container pt-2"
        *ngIf="searchAddress && searchAddressOptions && searchAddressOptions.length">
        <div class="autoaddress-options-list col-md-12 px-0" [ngClass]="isFromFboProfile ? '' : 'list-size' " [style.max-height.px]="listBlockHeight">
            <div (click)="searchAddressByDisplayName(addressOption)"
                *ngFor="let addressOption of searchAddressOptions; let i=index;"
                class="row autoaddress-options-item">
                <a>
                    <span class='pointer'>
                        <span class="pointer">{{addressOption.displayName}}</span>
                        <i class="float-right fa fa-list-ul"
                            *ngIf="addressOption.optionType && addressOption.optionType.text !== 'Standard'"></i>
                        <i class="float-right fa fa-chevron-right"
                            *ngIf="addressOption.optionType && addressOption.optionType.text === 'Standard'"></i>
                    </span>
                </a>
            </div>
        </div>
        <div class="col-md-12 py-1 px-0 back-link" *ngIf="searchAddressOptions && searchAddressOptions.length && showBackButton">
            <a class="py-1 px-2">
                <span class='pointer' (click)="showPreviousAddressList()"><i class="fa fa-chevron-left"></i>
                    <span class="pl-1 pointer">{{'breadcrumb.Back' |translate |translateKey}}</span></span>
            </a>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/address/search-address.component.html